export const ANALYTICS_TRACKING_KEY = 'analytics_pending'
export const ANALYTICS_TIMEOUT_MINUTES = 10

export interface AnalyticsTrackingItem {
  messageId: string
  conversationId: string
  query: string
  startedAt: string
  // Set for artifact Q&A conversations so the completion toast reopens the
  // artifact viewer (/artifacts/{artifactId}) instead of the analytics chat.
  artifactId?: string
}
